export default "__VITE_ASSET__F34qhoWg__"